<template>
  <CaseStudy
    title="MELANIA"
    :logo="require('@/assets/logos/melania.png')"
    :thumbnail="require('@/assets/screenshots/melania.png')"
    iframeLink="https://iframe.bubblemaps.io/map/5uO2HDn7VwN0OnRKqYG1?partnerId=demo"
    threadLink="https://x.com/bubblemaps/status/1891289507338580028"
    isOdd
    :featuredIn="[
      {
        name: 'Financial Times',
        logo: require('@/assets/logos/medias/financialtimes.png'),
        link: 'https://www.ft.com/content/f5797d16-6299-444c-b990-5cbc6a7ccfca',
        color: '#FDF2E6',
      },
      {
        name: 'Yahoo Finance',
        logo: require('@/assets/logos/medias/yahoo.png'),
        link: 'https://finance.yahoo.com/news/melania-trumps-memecoin-sees-huge-000147344.html',
        color: '#5F01D1',
      },
      {
        name: 'Decrypt',
        logo: require('@/assets/logos/medias/decrypt.png'),
        link: 'https://decrypt.co/313866/melania-solana-meme-coin-dumps-bubblemaps',
      },
    ]"
  >
    How Melania Trump’s meme coin launched with
    <b>heavy insider activity</b> and was later linked to Hayden Davis
  </CaseStudy>
</template>

<script>
import CaseStudy from "@/components/organisms/CaseStudies/CaseStudy.vue";

export default {
  components: {
    CaseStudy,
  },
};
</script>
